function setCookie(name, value, days) {
    var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }

    document.addEventListener('DOMContentLoaded', function() {
        // Cookies banner
        if (!getCookie('cookies_accepted')) {
            var cookiesBanner = document.getElementById('cookies-banner');
            if (cookiesBanner) {
                cookiesBanner.style.display = 'flex';
            }
        }
        // Popup
        if (!getCookie('popup_closed')) {
            var popup = document.querySelector('.js-popup');
            if (popup) {
                popup.style.display = 'flex';
            }
        }

        // Accept cookies
        var acceptBtn = document.querySelector('.js-accept-cookies');
        if (acceptBtn) {
            acceptBtn.addEventListener('click', function() {
                setCookie('cookies_accepted', '1', 365);
                var cookiesBanner = document.getElementById('cookies-banner');
                if (cookiesBanner) {
                    cookiesBanner.style.display = 'none';
                }
            });
        }

        // Close popup
        var closePopupBtn = document.querySelector('.js-popup-close');
        if (closePopupBtn) {
            closePopupBtn.addEventListener('click', function() {
                setCookie('popup_closed', '1', 30);
                var popup = document.querySelector('.js-popup');
                if (popup) {
                    popup.style.display = 'none';
                }
            });
        }
    });